'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './property-list.routes';

const moment = require('moment');

export class PropertyListComponent {
  constructor(Auth, PropertyService, dialogs, $scope, ViewSelection, DTOptionsBuilder, DTDefaultOptions, DTState) {
    'ngInject';

    this.$scope = $scope;
    this.ViewSelection = ViewSelection;

    this.PropertyService = PropertyService;
    this.filteredData = [];
    this.data = [];
    this.selectedCommunityCode = "";

    this.dialogs = dialogs;

    DTDefaultOptions.setLoadingTemplate( '<datatable-loading-placeholder columns="Cmty, Lot#, Address, Primary Owner, Other Owner, Active Tenant" />');

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('order', [0, 'asc'])
      .withOption('deferRender', true)
      .withOption('initComplete', _=> {this.initComplete = true})
      .withOption('stateSave',true)
      .withOption('stateSaveCallback', DTState.save())
      .withOption('stateLoadCallback', DTState.restore())
      .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
      .withOption('buttons',[{
        extend: 'excel',
        title: "Properties"
      },{
        extend: 'csv',
        title: "Properties"
      },{
        title: "Properties",
        message: 'As of ' + moment().format("MMMM Do YYYY"),
        extend: 'pdf',
        orientation: 'portrait',
        pageSize: 'LETTER'
      },{
        extend: 'print',
        title: "Properties"
      }]);

    this.PropertyService.query((data) => {
      this.data = data;
      this.filterData(ViewSelection.selectedCommunityCode);
      this.dataInitComplete = true;
    }, err => {
      console.log("Could not retrieve properties.")
    });

    $scope.ViewSelection = ViewSelection;
    $scope.$watch('ViewSelection.selectedCommunity', (newVal, oldVal, scope) => {
      this.selectedCommunity = newVal.name;
      this.selectedCommunityCode = newVal.value;
      this.filterData(this.selectedCommunityCode);
    });
  }

  filterData(code) {
    if (code) {
      this.filteredData = this.data.filter(ppty => ppty.community && ppty.community.code == code)
    } else {
      this.filteredData = this.data;
    }
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "") {
        composedName += contact.company;
      } else {
        composedName += "<br/>" + contact.company;
      }
    }

    return composedName;
  }

  getAddress(property) {
    try {
      let address = property.address.street;

      if (property.address.city && property.address.state && property.address.zip) {
        address += `, ${property.address.city} ${property.address.state}, ${property.address.zip}`;
      } else if (property.address.city) {
        address += `, ${property.address.city}`;
      } else if (property.address.state && property.address.zip) {
        address += `, ${property.address.state}, ${property.address.zip}`;
      }

      return address;
    } catch (e){
      return "-";
    }
  }

  delete(property) {
    var that = this;

    let address = "";
    try {
      address = this.getAddress(property);
    } catch (e){}

    var propertyText = "<br/><br/><b> Unit/Lot# " + property.lotNo + "</b><br/><p>" + address + "</p>";

    var dlg = this.dialogs.confirm("Delete Property?", "Do you really want to delete this property?" + propertyText);
    dlg.result.then(() => {
      // OK delete it
      that.PropertyService.delete({id: property._id},
        () => {
          that.data = that.data.filter(function( obj ) {
            return obj._id !== property._id;
          });

          that.filterData(that.selectedCommunityCode);
        },
        err => {
          alert("Could not delete property");
        });
    }, () => {
      // Cancel
    });
  }

  getPrimaryOwnerId(contacts) {
    let primary = contacts.find(contact => contact.type == 'primary-owner');

    if (!primary) // No Primary Owner
      return 0;
    else if (!primary.contact || !primary.contact._id) // Contact for Primary Owner deleted
      return -1;
    else 
      return primary.contact._id;
  }

  getOtherOwnerId(contacts) {
    let other = contacts.find(contact => contact.type == 'owner');

    if (!other) // No Other Owner
      return 0;
    else if (!other.contact || !other.contact._id) // Contact for Other Owner deleted
      return -1;
    else
      return other.contact._id;
  }

  getActiveTenantId(contacts) {
    let activeTenant = contacts.find(contact => {
      try {
        if (contact.type == 'renter') {

          if (!contact.from && !contact.till) // if no dates are defined, we assume thatt the renter should be the current one
            return true;

          if (contact.from && contact.till) {
            return moment().isBetween(moment(contact.from), moment(contact.till), "days", "[]");
          }

          if (!contact.from && contact.till) {
            return moment().isBefore(moment(contact.till)) || moment.isSame(moment(contact.till), "day");
          }

          if (contact.from && !contact.till) {
            return moment().isAfter(moment(contact.from)) || moment.isSame(moment(contact.from), "day");
          }
        } else {
          return false;
        }
        
      } catch(e) {
        console.log(e);
        return false;
      }
    });

    if (!activeTenant) // No Other Owner
      return 0;
    else if (!activeTenant.contact || !activeTenant.contact._id) // Contact for Other Owner deleted
      return -1;
    else
      return activeTenant.contact._id;
  }

  getPrimaryOwner(contacts) {
    if (!contacts || !contacts.length)
      return "-";

    let primary = contacts.find(contact => contact.type == 'primary-owner');

    if (!primary)
      return "-";

    return this.getComposedName(primary.contact);
  }

  getOtherOwner(contacts) {
    if (!contacts || !contacts.length)
      return "-";

    let other = contacts.find(contact => contact.type == 'owner');

    if (!other)
      return "-";

    return this.getComposedName(other.contact);
  }

  getActiveTenant(contacts) {
    if (!contacts || !contacts.length)
      return "-";

    let activeTenant = contacts.find(contact => {
      try {
        if (contact.type == 'renter') {

          if (!contact.from && !contact.till) // if no dates are defined, we assume thatt the renter should be the current one
            return true;

          if (contact.from && contact.till) {
            return moment().isBetween(moment(contact.from), moment(contact.till), "days", "[]");
          }

          if (!contact.from && contact.till) {
            return moment().isBefore(moment(contact.till)) || moment.isSame(moment(contact.till), "day");
          }

          if (contact.from && !contact.till) {
            return moment().isAfter(moment(contact.from)) || moment.isSame(moment(contact.from), "day");
          }
        } else {
          return false;
        }

      } catch(e) {
        console.log(e);
        return false;
      }
    });

    if (!activeTenant)
      return "-";

    return this.getComposedName(activeTenant.contact);
  }

}

export default angular.module('conduu.propertyList', [uiRouter])
  .config(routes)
  .component('propertyList', {
    template: require('./property-list.html'),
    controller: PropertyListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/portfolio/property-list/property-list.component.js